
// eslint-disable-next-line @typescript-eslint/no-restricted-imports

import Image from "next/image";
import Link from "next/link";
import { ReactNode } from "react";
// eslint-disable-next-line import/no-unresolved
import { Navigation } from "swiper/modules";
// eslint-disable-next-line import/no-unresolved
import { SwiperSlide, Swiper } from "swiper/react";
import { ProductWidgetsType } from "../../../../api/landingPage/widgets";
import { Money } from "../../../Money";
import { AddToCompareBtn } from "../../../Product/AddToCompareBtn";
import ProductAddToWishlistBtn from "../../../Product/ProductAddToWishlistBtn";
import IconShoppingCartFill from "../../../icons/iconCart";





type DiscountSelectionType = {
  items: ProductWidgetsType[];
  title: string;
  icon: ReactNode;
  className: string;
}

// eslint-disable-next-line import/no-default-export
export default function NewSelection(props: DiscountSelectionType) {
  const { items, className, icon, title } = props

  return (
    <div className={`flex flex-col justify-between items-center mt-16 mb-5 text-primary-500 mx-auto ${className}`}>
      <div className="border-dashed border-t-[1px] border-t-default-400 w-full items-start justify-start ">
        <h3 className=" flex flex-row items-center text-default-400 font-semibold text-xl bg-white w-fit px-5  -mt-[15px]">{icon} {title} </h3>
      </div>
      <div className={`h-[400px] w-full m-auto `}>
        <Swiper
          modules={[Navigation]}
          navigation
          breakpoints={{
            1: {
              slidesPerView: 1,
            },
            440: {
              slidesPerView: 2,
            },
            600: {
              slidesPerView: 3,
            },
            840: {
              slidesPerView: 4,
            },
            1000: {
              slidesPerView: 5,
            },
          }}
          spaceBetween={20}
          defaultValue={4}
          className=' !h-[380px] !px-5'
        >

          {items?.map((product) => (
            <SwiperSlide key={product?.id} className="relative shadow-md rounded-md bg-white my-auto !h-[90%] w-full overflow-hidden ">
              <div className="relative w-full h-full mt-0 md:mt-10 hover:md:mt-0 transition delay-300 ease-in-out animation duration-300">

                <Link href={`/p/${product?.url_key}`} key={product.id} className="w-full h-full flex flex-col items-center p-2">
                  <div className="w-full max-w-[180px]">
                    <Image className="w-full h-auto" width={100} height={100} src={product?.image?.url} alt="" />
                  </div>


                  <p className="text-sm text-center text-default-900 transition-colors truncate max-w-[90%]">
                    {product.name}
                  </p>

                  <div className="w-[90%] m-auto flex justify-between items-center mt-3">
                    <span className="text-base text-light-400 line-through">
                      {product?.price_range?.minimum_price?.discount?.percent_off > 0 && <Money showCurrency={false} {...product?.price_range?.minimum_price?.regular_price} />}

                    </span>
                    <span className=" flex flex-row text-base gap-[2px] items-center text-secondary-500 font-semibold">
                      <Money showCurrency={false} {...product?.price_range?.minimum_price?.final_price} />
                      <span className="text-xs text-default-800">تومان</span>
                    </span>
                  </div>

                </Link>
                <div className="flex bg-light-150 w-full h-auto  flex-row items-center align-middle justify-between absolute bottom-0 py-1 pl-4">

                  <Link href={`/p/${product?.url_key}`} key={product.id} className="bg-secondary-500 flex flex-row items-center p-1 text-sm text-white  rounded-2xl ">
                    <IconShoppingCartFill width={20} height={20} />
                    <p>
                      انتخاب گزینه
                    </p>
                  </Link>

                  <section className="flex flex-row items-center">

                    <AddToCompareBtn
                      product_name={product?.name ?? ''}
                      product_image_url={product?.image?.url ?? ''}
                      compare_product_id={product?.id}
                      className="!text-default-100 hover:!text-primary-500 !bg-transparent !shadow-none"
                    />
                    <ProductAddToWishlistBtn {...(product as any)} size={25} />
                  </section>

                </div>
              </div>
              {product?.price_range?.minimum_price?.discount?.percent_off > 0 &&
                <span className="w-9 h-9 bg-error-500 absolute right-2 top-2 text-center text-sm text-white flex items-center justify-center rounded-full ">
                  %{Math.round(product?.price_range?.minimum_price?.discount?.percent_off)}
                </span>}
            </SwiperSlide>

          ))}
        </Swiper>




      </div>
    </div>
  )
}